import { commonTypes } from "./common";

export const initialState = {
  choices: null,
  installationAddress: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const SummaryInfoReducer = (
  state = JSON.parse(JSON.stringify(initialState)),
  action
) => {
  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        ...state,
        choices: null,
        installationAddress: null,
      };
    }
    case commonTypes.SET_INSTALLATION_ADDRESS: {
      const { installationAddress } = action.payload;

      if (installationAddress.fullAddress) {
        return {
          ...state,
          installationAddress: {
            ...state.installationAddress,
            address: installationAddress.fullAddress,
          },
        };
      }
      return {
        ...state,
      };
    }
    case commonTypes.SET_INSTALLATION_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        installationAddress: {
          ...state.installationAddress,
          address,
        },
      };
    }
    case commonTypes.SET_AFTER_SALE_PARENT_PRODUCT: {
      const { afterSaleParentProduct } = action.payload;
      
      if (afterSaleParentProduct) {
        return {
          ...state,
          afterSaleParentProduct,
        };
      }
      return { ...state };
    }
    default:
      return { ...state };
  }
};

export default SummaryInfoReducer;
